import http from 'conversations-http/clients/http';
export const fetchSpaceClient = ({
  spaceId
}) => http.get(`hd-spaces/v1/spaces/${spaceId}`);